module.exports = __webpack_public_path__ + "img/DSC_2882-xs.288ed68d.png";